import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE, SERVICE_AREAS } from "../data/site";

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-white/10 pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-12">
        <div>
          <Link to="/" className="flex items-center gap-3 mb-5">
            <img src={SITE.logo} alt="USA Limo Service" className="h-14 w-14 object-contain" />
            <div>
              <div className="font-display text-xl text-white">USA Limo Service</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/50">Luxury Since 1984</div>
            </div>
          </Link>
          <p className="text-sm text-white/60 leading-relaxed">
            The #1 luxury transportation provider in Washington DC, Virginia and Maryland.
            Executive chauffeurs, pristine fleet, and uncompromising service — since 1984.
          </p>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.3em] uppercase text-white/40 mb-5">Services</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/services/airport-transportation" className="hover:text-white">Airport Transportation</Link></li>
            <li><Link to="/services/corporate-travel" className="hover:text-white">Corporate Travel</Link></li>
            <li><Link to="/services/special-events" className="hover:text-white">Weddings & Special Events</Link></li>
            <li><Link to="/services/wine-tours" className="hover:text-white">Wine Tours</Link></li>
            <li><Link to="/services/armed-security-transportation" className="hover:text-white">Armed Security</Link></li>
            <li><Link to="/executive-chauffeur" className="hover:text-white">Executive Chauffeur</Link></li>
            <li><Link to="/zuber-valet" className="hover:text-white">Zuber Valet Service</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.3em] uppercase text-white/40 mb-5">Service Areas</h4>
          <ul className="space-y-2 text-sm text-white/70 columns-2">
            {SERVICE_AREAS.map((a) => (<li key={a}>{a}</li>))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.3em] uppercase text-white/40 mb-5">Contact</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 text-[#9B1B30]" />
              <div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-white/40">Office</div>
                <a href={`tel:${SITE.phonesTel.office}`} className="hover:text-white">{SITE.phones.office}</a>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 text-[#9B1B30]" />
              <div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-white/40">Virginia</div>
                <a href={`tel:${SITE.phonesTel.virginia}`} className="hover:text-white">{SITE.phones.virginia}</a>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 text-[#9B1B30]" />
              <div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-white/40">Dispatch · 24/7</div>
                <a href={`tel:${SITE.phonesTel.dispatch}`} className="hover:text-white">{SITE.phones.dispatch}</a>
              </div>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-[#9B1B30]" />
              <a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={16} className="text-[#9B1B30]" /> {SITE.address}
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
        <div>© {new Date().getFullYear()} USA Limo Service. All rights reserved. Licensed & insured throughout the DMV.</div>
        <div className="flex gap-6 items-center">
          <Link to="/contact" className="hover:text-white">Contact</Link>
          <Link to="/book" className="hover:text-white">Book Online</Link>
          <Link to="/admin/login" className="hover:text-white">Admin</Link>
          <a
            href="https://WebNehTech.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white tracking-wider"
            data-testid="powered-by"
          >
            Powered by <span className="text-white/70">WebNehTech.com</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
